export interface UserBubbleProps {
  /** Plain text. No markdown: an FAQ click and a typed question look identical. */
  text: string;
}

/** The user's turn. Right-aligned navy; no avatar, no label, no timestamp. */
export function UserBubble({ text }: UserBubbleProps) {
  return (
    <div className="flex justify-end">
      <span className="box-border max-w-[86%] rounded-[12px_12px_4px_12px] bg-dvaNavy px-3.5 py-2.5 text-sm font-medium leading-[1.5] text-white animate-[dvaHelpRiseIn_160ms_ease-out]">
        {text}
      </span>
    </div>
  );
}
